var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ line: _vm.row === 1, lines: _vm.row > 1 },style:({ '--row': _vm.row })},[_vm._v(" "+_vm._s(_vm.content || "\\")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }